export const SORTING_CATEGORY_LIST = {
    ASC: 1,
    DESC: -1,
  };